var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9723 9.62807C16.9723 8.90531 16.915 8.37807 16.7911 7.83105H8.73633V11.0931H13.4644C13.3689 11.9037 12.8543 13.1246 11.7104 13.9449L11.6944 14.0539L14.2412 16.0753L14.4177 16.0934C16.0382 14.56 16.9723 12.3038 16.9723 9.62807Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73628 18.2224C11.0526 18.2224 12.9971 17.4412 14.4177 16.0934L11.7106 13.9449C10.9861 14.4625 10.0137 14.8239 8.73656 14.8239C6.46797 14.8239 4.54245 13.2905 3.85602 11.1714L3.75536 11.1801L1.10701 13.2798L1.07227 13.3784C2.48317 16.2496 5.38083 18.2224 8.73628 18.2224Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85576 11.1713C3.67457 10.6243 3.56977 10.0383 3.56977 9.4328C3.56977 8.8273 3.67457 8.24129 3.8461 7.69428L3.84142 7.57787L1.15997 5.44434L1.07228 5.487C0.490924 6.67879 0.157227 8.01695 0.157227 9.4328C0.157227 10.8487 0.490924 12.1868 1.07228 13.3783L3.85576 11.1713Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73628 4.04185C10.3471 4.04185 11.434 4.75473 12.0534 5.35062L14.4745 2.92861C12.9878 1.51219 11.0529 0.643066 8.73628 0.643066C5.38083 0.643066 2.48317 2.61583 1.07227 5.48709L3.84609 7.69437C4.54217 5.57497 6.46769 4.04185 8.73628 4.04185Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9b8c0d7c.svg";
export { ForwardRef as ReactComponent };